export default class LicenseApi {
    static findLicenseByRoute(routeParam){
        return fetch(`/api/license`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify(routeParam)
        })
        .then(res => res.json())
        .then(
        (result) => {
            return result
        },
        (error) => {
            return error
        }
        )
    }
}